var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgV3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 63,
    viewBox: "0 0 52 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.1304 28.6364C51.1304 44.5295 40.2504 59.3918 25.6304 63C11.0104 59.3918 0.130371 44.5295 0.130371 28.6364V11.4545L25.6304 0L51.1304 11.4545V28.6364ZM25.6304 57.2727C36.2554 54.4091 45.4637 41.6373 45.4637 29.2664V15.1773L25.6304 6.24273L5.79704 15.1773V29.2664C5.79704 41.6373 15.0054 54.4091 25.6304 57.2727ZM25.6304 13.4018C27.047 13.4018 28.322 14.6332 28.322 16.1223V26.0877L42.6304 35.1082V38.745L28.322 34.2205V44.1573L31.892 46.8777V49.5982L25.6304 47.7655L19.3687 49.5982V46.8777L22.9387 44.1573V34.2205L8.63037 38.745V35.1082L22.9387 26.0877V16.1223C22.9387 14.6332 24.2137 13.4018 25.6304 13.4018Z",
    fill: "#C49A6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV3);
export default __webpack_public_path__ + "static/media/V3.af7bdc275a2d5e6cbf64e8a4bbe31bcd.svg";
export { ForwardRef as ReactComponent };